import { CLM } from "@/common/schema/claims";
import { App } from "@/common/schema/claims-apps";
import { urls } from "@/common/urls";
import { LinkButton } from "@/ui/controls/buttons";

export function DefaultAppLink({ currentUser, currentApp }: { currentUser: CLM.User, currentApp?: App }) {
  const URLS = urls({ ts: "NOW" });

  const defaultApp  = currentUser.roleType.defaultApp;
  const home = URLS.home({ app: defaultApp });

  return <>
    { defaultApp !== currentApp && <p className="text-sm pb-2">Trying to access the {defaultApp.name} app? <LinkButton url={home}>Open app</LinkButton></p> }
  </>
}
